import 'isomorphic-fetch';

import { ApiFactory } from 'helper/api/factory';
import { Config } from 'models/config';

let api = new ApiFactory('', '', '');

export function configureApi(config: Config) {
  api = new ApiFactory(config.apiUrl, config.clientId, config.clientSecret, config.timeout);
}

export { api };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/api/index.ts